import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';

@Component({
  selector: 'app-show-otp',
  templateUrl: './show-otp.component.html',
  styleUrls: ['./show-otp.component.scss']
})
export class ShowOtpComponent implements OnInit {

  delivery: Delivery;
  showFeedback = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery },
  ) { 
    this.delivery = this.data.delivery;
  }
  
  copyOTP() {
    const otp = this.delivery?.deliveryCode;
    if (otp) {
      navigator.clipboard.writeText(otp).then(() => {
        this.showFeedback = true;
        setTimeout(() => {
          this.showFeedback = false;
        }, 2000);
      });
    }
  }

  ngOnInit(): void {
  }

}
